import { ReactNode } from 'react'
import * as S from './divided-container.styles'

interface IDividedContainerProps {
  left: ReactNode
  right: ReactNode
}

export const DividedContainer = ({ left, right }: IDividedContainerProps) => {
  return (
    <S.Container>
      <S.Wrapper>{left}</S.Wrapper>
      <S.Wrapper>{right}</S.Wrapper>
    </S.Container>
  )
}
